import { Dispatcher } from 'flux';

export interface IAppDispatcher extends Dispatcher<any> {
    get(dispatcherName: string): Dispatcher<any>;
}

const dispatchers: { [id: string]: Dispatcher<any> } = {};
const AppDispatcher: IAppDispatcher = new Dispatcher<any>() as any;

(AppDispatcher as any).get = function (dispatcherName: string) {
    if (!dispatchers[dispatcherName]) {
        dispatchers[dispatcherName] = new Dispatcher<any>();
    }
    return dispatchers[dispatcherName];
};

export default AppDispatcher;
